import { ArtifactThemesContext } from "./../context/ArtifactsContext";
import { getArtifactThemes } from "./../api/api";
import { useContext, useEffect, useState } from "react";
import { ArtifactTheme } from "../models/client";

export const useGetArtifacts = (): [boolean, ArtifactTheme[]] => {
  const { artifactThemes, setArtifactThemes } = useContext(
    ArtifactThemesContext
  );
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!artifactThemes.length) {
      getArtifactThemes().then((artifactThemes) => {
        if (artifactThemes) {
          setArtifactThemes(artifactThemes);
        }
        setIsLoaded(true);
      });
    } else {
      setIsLoaded(true);
    }
  }, [setArtifactThemes, artifactThemes]);
  return [isLoaded, artifactThemes];
};
